import { Component, Input, OnInit,Inject } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { FileViewExplorerComponent } from "src/app/file-view-explorer/file-view-explorer.component";
import { CommonService } from "src/app/services/common.service";
@Component({
  selector: "app-casehistory",
  templateUrl: "./casehistory.component.html",
  styleUrls: ["./casehistory.component.scss"],
})
export class CasehistoryComponent implements OnInit {
  //@Input() casehistory = [];
  PatientHistory: any[] = [];
  deploymentKey:string='';
  constructor(
    private service: CommonService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    @Inject('caseData') public casehistory: any
  ) {}
  ngOnInit() {
    this.getCaseHistory();
  }
  async getCaseHistory() {
    if (this.casehistory.patientHistory.length > 0) {
      this.PatientHistory = [];
      this.deploymentKey=this.casehistory.deployment;
      for (let i = 0; i < this.casehistory.patientHistory.length; i++) {
        let obj = {
          CaseGuid: this.casehistory.patientHistory[i].CaseGuid,
          DeploymentKey: this.deploymentKey,
        };
        this.ngxUiLoaderService.start();
        let data=await this.service.postapi('api/Case360/GetCaseXML',obj);
        this.PatientHistory.push(data);
        this.ngxUiLoaderService.stop();
      }
      console.log(this.PatientHistory);
      if(this.PatientHistory.length>0){
        this.service.auditsave("View","","Viewed patient history details","case",
        this.casehistory["CaseGuid"],"Patient history tab ,deployment key :-" + this.deploymentKey
      );
    }
    } else {
      this.PatientHistory = [];
        this.toastr.warning(
          "No Patient History Found",
          "",
          {
            positionClass: "toast-bottom-right",
            timeOut: 4000,
          }
        );
    }
  }

  viewCase(item: object) {
    let obj = {
      ...this.service.CaseDataDetails,
      casedata: JSON.stringify(item),
    };
    this.service.updateCaseXMLToComponent(JSON.stringify(obj));
  }

  showRequReport(caseData: any) {
    if (typeof caseData.Attachments.File === "object") {
      this.viewCaseFile(caseData.Attachments.File, caseData);
    } else if (Array.isArray(caseData.Attachments.File)) {
      let datas = caseData.Attachments.File.filter(
        (va) => va.Category === "Requisition"
      );
      if (datas.length > 0) {
        this.viewCaseFile(datas[datas.length - 1], caseData);
      }
    }
  }

  showFinalReport(report: any, caseData: any) {
    if (typeof report === "object") {
      this.viewCaseFile(report.File, caseData);
    } else if (Array.isArray(report)) {
      // for (let i = 0; i < report.length; i++) {
      this.viewCaseFile(report[report.length - 1].File, caseData);
      // }
    }
  }

  viewCaseFile(report, caseData) {
    let location;
    if (caseData["ServiceProvider"].length > 0) {
      location = caseData["ServiceProvider"].find(
        (value) => value.Location.AccountType == "Laboratory"
      );
      if (location !== undefined) {
        location = location.Location;
      }
    } else {
      location = caseData["ServiceProvider"].Location;
    }

    let obj = {
      RequestID: report.PresentationData,
      Type: report.Category,
      RequestGUID: report.FileGUID,
      LabOrgGUID: location.OrganizationGUID,
      CaseGUID: caseData["CaseGUID"],
      DeploymentsKey: this.deploymentKey == undefined ? '' : this.deploymentKey,
    };
    this.ngxUiLoaderService.start();
    this.service.viewCases360DXReport(obj).subscribe(
      (data) => {
        this.ngxUiLoaderService.stop();
        if (
          data.StatusMessage !== null &&
          data.StatusMessage.toLowerCase() !== "failed"
        ) {
          if (data["FileContent"] !== null) {
            "data:application/pdf;base64," + data["FileContent"];
            let namemodal = {
              name: report.ReportName,
              fullfile: data["FileContent"],
            };
            this.service.auditsave(
              "View",
              "",
              "Viewed case360 dx report :-" + report.ReportName,
              "case",
              caseData["CaseGUID"],
              "Patient history tab ,deployment key :-" + this.deploymentKey
            );
            const modalRef = this.modalService.open(FileViewExplorerComponent, {
              windowClass: "myCustomModalViewfile",
              backdrop: "static",
              keyboard: false,
            });
            modalRef.componentInstance.fileData = namemodal;
            modalRef.result.then(() => {});
          } else {
            this.ngxUiLoaderService.stop();
            this.toastr.warning("Data not Found", "Alert", {
              positionClass: "toast-bottom-right",
              timeOut: 4000,
            });
          }
        } else {
          this.ngxUiLoaderService.stop();
          data.FileContent !== null && data.FileContent !== ""
            ? this.toastr.error(data.FileContent, "Failed", {
              positionClass: "toast-bottom-right",
              timeOut: 4000,
            })
            : this.toastr.warning("Data not Found", "Alert", {
              positionClass: "toast-bottom-right",
              timeOut: 4000,
            });
        }
      },
      (error) => {
        this.ngxUiLoaderService.stop();
      }
    );
  }
}
